import AXIOS from './axiosClient'

class BasketService {

  loadOffers() {
    return AXIOS.get("/basket");
  }

  createOffer(offer) {
    return AXIOS.post("/basket", offer)
  }

  updateOffer(offer) {
    return AXIOS.post("", offer)
  }

  deleteOffer(offer) {
    return AXIOS.delete("/basket/" + offer.id)
  }
}


export default new BasketService();